import { animateScale } from '../../utils/Animations';
import Container = PIXI.Container;
import Text = PIXI.Text;
import TextStyle = PIXI.TextStyle;

export class TextIncrement extends Text {
  private stepDuration: number = 40;
  private totalSteps: number = 20;
  private intervalId: any;

  constructor(
    private currentValue: number = 1,
    private prefix: string = '',
    private suffix: string = '',
    style: TextStyle,
    parent?: Container,
    private scaleOnComplete: boolean = false,
    private targetValue?: number,
    incrementOnConstructor: boolean = false
  ) {
    super(prefix + currentValue + suffix, style);
    if (parent) {
      parent.addChild(this);
    }
    if (incrementOnConstructor) {
      this.startSteps();
    }
  }

  public startSteps(targetValue?: number): void {
    this.cacheAsBitmap = false;
    if (targetValue) {
      this.targetValue = targetValue;
    }
    let stepValue: number = Math.round((this.targetValue - this.currentValue) / this.totalSteps);
    if (stepValue === 0) {
      stepValue = 1;
    }
    this.intervalId = setInterval((): void => {
      this.currentValue += stepValue;
      if (this.currentValue >= this.targetValue) {
        this.currentValue = this.targetValue;
        clearInterval(this.intervalId);
        this.cacheAsBitmap = true;
        if (this.scaleOnComplete && this.scale) {
          animateScale(this);
        }
      }
      this.updateLabel();
    }, this.stepDuration);
  }

  public updateLabel(value?: string): void {
    if (value) {
      this.cacheAsBitmap = false;
      clearInterval(this.intervalId);
      this.text = value;
      this.cacheAsBitmap = true;
      animateScale(this);
    } else {
      this.text = this.prefix + this.currentValue + this.suffix;
    }
  }

  public stop(): void {
    clearInterval(this.intervalId);
  }

  public destroy(options?: { children?: boolean; texture?: boolean; baseTexture?: boolean }): void {
    clearInterval(this.intervalId);
    super.destroy(options);
  }
}